import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

const HOVER_CAPABILITY_QUERY = '(hover: hover) and (pointer: fine)';

function getHoverCapabilityQuery(): MediaQueryList | null {
  if (
    Platform.OS !== 'web' ||
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return null;
  }

  return window.matchMedia(HOVER_CAPABILITY_QUERY);
}

export function useHoverCapability(): boolean {
  const [canHover, setCanHover] = useState(() => getHoverCapabilityQuery()?.matches ?? false);

  useEffect(() => {
    const mediaQuery = getHoverCapabilityQuery();
    if (!mediaQuery) {
      setCanHover(false);
      return;
    }

    setCanHover(mediaQuery.matches);
    const handleChange = (event: MediaQueryListEvent) => setCanHover(event.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return canHover;
}
